import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import info from './modules/info';
import contract from './modules/contract';
import repayment from './modules/repayment';
import loan from './modules/loan';
import auth from './modules/auth';
import help from './modules/help';
import vehicle from './modules/vehicle';
import driver from './modules/driver';
import balance from './modules/balance';
import violationManage from './modules/violation-manage';
import common from './modules/common';
import vinsurance from './modules/vinsurance';
import fundLoanManage from './modules/fund/loan-manage';
import merchantLoanManage from './modules/merchant/loan-manage';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        user: user,
        info: info,
        common: common,
        contract: contract,
        repayment: repayment,
        loan: loan,
        auth: auth,
        vehicle: vehicle,
        driver: driver,
        balance: balance,
        vinsurance: vinsurance,
        help: help,
        violationManage: violationManage,
        fundLoanManage: fundLoanManage,
        merchantLoanManage: merchantLoanManage,
    },
});
